import styled from 'styled-components';
import { Typography } from '@mui/material';

import colors from '../../../../../../../styles/colors';

const NotConnectedBanner = styled.div`
  background-color: ${colors.base.gamma};
  border-radius: 5px;
  padding: 10px 14px;
  margin-bottom: 8px;
`;

const NotConnectedText = styled(Typography)`
  font-size: 13px;
  font-weight: 400;
  color: ${colors.shades.gamma7};
`;

export {
  NotConnectedBanner,
  NotConnectedText,
};
